import Widget from '@/models/WidgetModel';
import Screen from 'quasar/src/plugins/screen/Screen.js';;
import Background from '@/models/BackgroundModel';

// Модуль для получения бэкраунда
export default function (widget: Widget): Background {
	const background = {} as Background;

	if (widget.bg_image_color) {
		background.backgroundColor = widget.bg_image_color;
	}

	if (widget.bg_image_file_webp) {
		const isSafari = /safari/.test(navigator.userAgent.toLowerCase());
		let link;

		// Для сафари берем просто jpg
		if (isSafari) {
			link = widget.bg_image_file;
		} else if (Screen.name === 'xs') {
			// Для мобильного устройства подставляем фон по хуже качества
			link = widget.bg_image_file_webp_xs;
		} else {
			link = widget.bg_image_file_webp;
		}

		// Дополнительно подгружаем в самом начале картинку, чтобы не было эффекта
		// при открытом виджете, что картинка не успела прогрузитсья
		const image = new Image();
		image.src = link ?? '';

		background.backgroundImage = `url('${link}')`;
	}

	return background;
}
